// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:010e3887-6661-442d-9f9c-efa31879cbcd",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_NvDMrbebj",
    "aws_user_pools_web_client_id": "4si7vlvgko0od4k5g0pjefbe7v",
    "oauth": {
        "domain": "ecommerce297f4c6b-297f4c6b-prod.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https:answerseguros.com.ar/admin/auth/",
        "redirectSignOut": "https:answerseguros.com.ar/home/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;
